export default __webpack_public_path__ + "static/media/partner-mb.0ca05a2c.png";